import React from 'react';
// import '../documents/Tiptap.css'; // <-- Import the Tiptap CSS file here

const DocumentViewer = ({ document }) => {
    return (
        <div className="document-viewer">
            <h2>{document.title}</h2>
            <hr />
            <div dangerouslySetInnerHTML={{ __html: document.content }} />
        </div>
    );
};

export default DocumentViewer;
